import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import Logo from "@/components/Logo";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      // Even on error we show success to avoid email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen-safe bg-obsidian text-white flex items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="glass-card rounded-md p-8 sm:p-10 max-w-md w-full">
        <div className="mb-6 flex justify-center"><Logo /></div>
        <button
          onClick={() => navigate("/login")}
          className="text-faded hover:text-gold-light text-xs mb-4 flex items-center gap-1"
          data-testid="forgot-back-btn"
        >
          <ArrowLeft className="w-3 h-3" /> {t("auth_back_to_login")}
        </button>
        {!sent ? (
          <>
            <h1 className="font-display text-3xl text-gold-light mb-2">{t("fp_title")}</h1>
            <p className="text-muted text-sm mb-6">{t("fp_subtitle")}</p>
            <form onSubmit={submit}>
              <label className="font-label text-faded block mb-2">{t("fp_email_label")}</label>
              <div className="relative mb-6">
                <Mail className="w-4 h-4 text-faded absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type="email"
                  required
                  className="input-field pl-10"
                  placeholder={t("fp_email_placeholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email"
                  autoFocus
                />
              </div>
              <button type="submit" disabled={loading} className="btn-gold w-full justify-center" data-testid="forgot-submit">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                {loading ? t("fp_sending") : t("fp_send_cta")}
              </button>
            </form>
          </>
        ) : (
          <>
            <h1 className="font-display text-3xl text-gold-light mb-2">{t("fp_check_email_title")}</h1>
            <p className="text-muted text-sm mb-6">
              {t("fp_check_email_body_prefix")} <strong className="text-gold-light">{email}</strong> {t("fp_check_email_body_suffix")}
            </p>
            <Link to="/login" className="btn-gold w-full justify-center" data-testid="forgot-back-login">
              {t("auth_back_to_login")}
            </Link>
          </>
        )}
        <p className="text-faded text-xs text-center mt-6">
          {t("fp_need_help")} <a href="mailto:support@keepsoul.app" className="text-gold-light hover:underline">support@keepsoul.app</a>
        </p>
      </div>
    </div>
  );
}
